/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const updateVoicePreferencesBodySpeechSpeedMin = 0.25;
export const updateVoicePreferencesBodySpeechSpeedMax = 1.5;

export const UpdateVoicePreferencesBody = zod.object({
  speechSpeed: zod
    .number()
    .min(updateVoicePreferencesBodySpeechSpeedMin)
    .max(updateVoicePreferencesBodySpeechSpeedMax)
    .optional()
    .describe(
      'How fast the realtime voice agent speaks: a multiplier from 0.25 to 1.5, where 1.0 is normal.',
    ),
});

export type UpdateVoicePreferencesBody = zod.input<typeof UpdateVoicePreferencesBody>;
export type UpdateVoicePreferencesBodyOutput = zod.output<typeof UpdateVoicePreferencesBody>;
